import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from './api-base.service';

const BASE_URL = 'user-profiles/user';
@Injectable({
  providedIn: 'root'
})
export class UsersProfileService extends ApiBaseService {
  list(userId: number): Observable<any> {
    return this.GET(this.getUrl((`/${BASE_URL}/${userId}`)));
  }

  delete(userId: number,userProfileId:number): Observable<any> {
     return this.DELETE(this.getUrl(`/${BASE_URL}/${userId}/${userProfileId}`));
  }

  create(userId: number | undefined, data: any): Observable<any> {
    return this.POST(this.getUrl((`/${BASE_URL}/${userId}`)), data);
  }

  update(userId: number, userProfileId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`/${BASE_URL}/${userId}/${userProfileId}`), data);
  }

  changeUserProfileStatus(userProfileId: number, status: string): Observable<any> {
    return this.POST(this.getUrl(`/auth/switch-profile/${userProfileId}`), { status });
  }
  
}
